import { render, staticRenderFns } from "./ChooseProducts.vue?vue&type=template&id=16bcd1a0&scoped=true"
import script from "./ChooseProducts.vue?vue&type=script&lang=js"
export * from "./ChooseProducts.vue?vue&type=script&lang=js"
import style0 from "./ChooseProducts.vue?vue&type=style&index=0&id=16bcd1a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bcd1a0",
  null
  
)

export default component.exports